// 其他信息
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let other = get(state, 'currentContractorDetail.contractorInfo.extraInfo.other', {})
  return {
    title: i18n.gettext('其他'),
    content: [
      {
        title: i18n.gettext('附件说明'),
        label: other.desc
      },
      {
        title: i18n.gettext('附件照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: other.pics
      }
      // {
      //   title: i18n.gettext('附件文件'),
      //   content: i18n.gettext('查看'),
      //   isLink: true,
      //   arrow: true,
      //   pics: other.files
      // }
    ]
  }
}
